import { isIsoDateString } from './is-iso-date-string.js';
export function isDateSelected(date, dateType) {
    return ((date != null && date instanceof Date && dateType !== 'string') ||
        (dateType === 'string' && isIsoDateString(date)));
}
